var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgLinkedin = function SvgLinkedin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0C586C",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: "24px",
    height: "24px",
    stroke: "#0c586c",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,25H4V10h5V25z M6.501,8C5.118,8,4,6.879,4,5.499S5.12,3,6.501,3C7.879,3,9,4.121,9,5.499C9,6.879,7.879,8,6.501,8z M27,25h-4.807v-7.3c0-1.741-0.033-3.98-2.499-3.98c-2.503,0-2.888,1.896-2.888,3.854V25H12V9.989h4.614v2.051h0.065 c0.642-1.18,2.211-2.424,4.551-2.424c4.87,0,5.77,3.109,5.77,7.151C27,16.767,27,25,27,25z"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedin);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+PHN2ZyBmaWxsPSIjMEM1ODZDIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB2aWV3Qm94PSIwIDAgMzAgMzAiIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHN0cm9rZT0iIzBjNTg2YyIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwYXRoIGQ9Ik05LDI1SDRWMTBoNVYyNXogTTYuNTAxLDhDNS4xMTgsOCw0LDYuODc5LDQsNS40OTlTNS4xMiwzLDYuNTAxLDNDNy44NzksMyw5LDQuMTIxLDksNS40OTlDOSw2Ljg3OSw3Ljg3OSw4LDYuNTAxLDh6IE0yNywyNWgtNC44MDd2LTcuM2MwLTEuNzQxLTAuMDMzLTMuOTgtMi40OTktMy45OGMtMi41MDMsMC0yLjg4OCwxLjg5Ni0yLjg4OCwzLjg1NFYyNUgxMlY5Ljk4OWg0LjYxNHYyLjA1MWgwLjA2NSBjMC42NDItMS4xOCwyLjIxMS0yLjQyNCw0LjU1MS0yLjQyNGM0Ljg3LDAsNS43NywzLjEwOSw1Ljc3LDcuMTUxQzI3LDE2Ljc2NywyNywyNSwyNywyNXoiLz48L3N2Zz4=";